<template>
  <div class="absolute top-0 left-0 min-h-screen bg-black bg-opacity-40 flex justify-center items-center w-full z-10"
       v-show="value">
    <div class="bg-white rounded-lg">
      <div class="w-96 border-t-8 border-red-600 rounded-lg flex">
        <div class="w-1/3 pt-6 flex justify-center items-center">
          <font-awesome-icon class="bg-red-600 text-white rounded-full text-6xl block"
                             icon="exclamation-circle"></font-awesome-icon>
        </div>
        <div class="w-full pt-9 pr-4">
          <h3 class="font-bold text-red-700">{{ title }}</h3>
          <p class="py-4 text-lg text-gray-400">{{ message }}</p>
        </div>
      </div>

      <div class="p-4 flex space-x-4">
        <a href="#"
           class="w-1/2 px-4 py-3 text-center bg-gray-100 text-gray-400 hover:bg-gray-200 hover:text-black font-bold rounded-lg text-sm"
           @click="$emit('cancel')">Cancel</a>
        <a href="#"
           class="w-1/2 px-4 py-3 text-center text-red-100 bg-red-600 rounded-lg hover:bg-pink-700 hover:text-white font-bold text-sm"
           @click="$emit('ok')">Delete</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dialogComponent",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Title'
    },
    message: {
      type: String,
      default: 'Message'
    }
  }
}
</script>

<style scoped>

</style>